/*
 * drool-sizeup.js  (additive — safe to remove / toggle off)
 *
 * "Go bigger?" add-to-cart upsell for the CARDS (B) arm only. Gated by the chosen
 * size, with intensity + angle that scale with the jump:
 *   Small  → Large (Popular)   · MODAL  (hardest)   · visual scale
 *   Medium → Large             · SHEET  (standard)  · visual scale
 *   Large  → Large/XL (+£)     · SOFT   (light)     · price delta
 *   Large/XL → XL              · SOFT   (very soft) · price delta
 *   XL (biggest) → never
 *
 * NEVER blocks the add: whatever the shopper does, an item enters the bag —
 * upgrade adds the bigger one, keep / ✕ / click-away adds the one they chose.
 * Frequency cap: fires at most once per product per session.
 *
 * SAFETY:
 *  - Off switch: cards block setting "Size-up intercept" → data-sizeup="false".
 *  - Only the MAIN add button, only when the cards arm is the visible (B) arm.
 *  - Everything is wrapped in try/catch; on ANY error the normal add proceeds.
 *  - Adds via the theme's own add button (we re-click it) so cart/drawer are native.
 */
(function () {
  'use strict';

  var bypass = false;       // when true, let the (re-dispatched) add click through untouched
  var SHEET = null, SCRIM = null;

  function cardsArm() { return document.querySelector('.drool-picker-cards'); }
  function fieldset() { var a = cardsArm(); return a && a.querySelector('.mrk-size-cards'); }
  function isEnabled(fs) { return fs && fs.getAttribute('data-sizeup') !== 'false'; }
  function armVisible() {
    var a = cardsArm();
    return !!(a && getComputedStyle(a).display !== 'none' && a.offsetParent !== null);
  }
  // ONLY the main product add-to-cart. Excludes the bundle / "complete the look"
  // button and the many Rebuy cart-upsell buttons (mrk-cart-upsell-add-to-cart).
  function isMainAdd(btn) {
    return !!(btn && btn.classList && btn.classList.contains('mrk-main-add-to-cart'));
  }

  function areaOf(v) {
    if (!v) return 0; v = String(v);
    var cm = v.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
    if (cm) return (cm[1] / 2.54) * (cm[2] / 2.54);
    var inch = v.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if (inch) return inch[1] * inch[2];
    return 0;
  }
  function readSizes(fs) {
    return Array.prototype.map.call(fs.querySelectorAll('.mrk-sc__cardwrap'), function (w) {
      var r = w.querySelector('input[type=radio]');
      var pe = w.querySelector('.mrk-sc__price');
      var price = pe ? parseFloat((pe.getAttribute('data-money') || '').replace(/[^0-9.]/g, '')) / 100 : NaN;
      if ((isNaN(price) || !price) && pe) price = parseFloat((pe.textContent || '').replace(/[^0-9.]/g, ''));
      return {
        radio: r, value: w.getAttribute('data-value'),
        name: ((w.querySelector('.mrk-sc__name') || {}).textContent || '').trim(),
        dim: ((w.querySelector('.mrk-sc__dimval') || w.querySelector('.mrk-sc__dims') || {}).textContent || '').trim(),
        area: areaOf(w.getAttribute('data-value')),
        price: price,
        checked: !!(r && r.checked),
        available: w.getAttribute('data-available') !== 'false'
      };
    });
  }
  // Decide IF and HOW to upsell, gated by the chosen size (see header table).
  // Returns {cur, reco, treatment, angle, popularTag} or null (don't fire).
  function config(fs) {
    var sizes = readSizes(fs);
    var popName = (fs.getAttribute('data-popular-on') || 'Large').toLowerCase();
    var curIdx = -1, popIdx = -1, lastIdx = -1;
    for (var i = 0; i < sizes.length; i++) {
      var s = sizes[i];
      if (s.checked) curIdx = i;
      if (popIdx < 0 && (s.name.toLowerCase() === popName || String(s.value).toLowerCase().indexOf(popName) !== -1)) popIdx = i;
      if (s.area > 0 && s.available) lastIdx = i;
    }
    if (curIdx < 0 || !sizes[curIdx].area) return null;
    if (curIdx >= lastIdx) return null;                                   // biggest available → never fire
    var cur = sizes[curIdx], reco = null;
    if (popIdx >= 0 && curIdx < popIdx && sizes[popIdx].available) reco = sizes[popIdx];   // below Popular → push Popular
    if (!reco) { for (var m = curIdx + 1; m < sizes.length; m++) { if (sizes[m].area > cur.area && sizes[m].available) { reco = sizes[m]; break; } } } // else next size up
    if (!reco) return null;
    var treatment = 'sheet';
    if (popIdx >= 0) treatment = (curIdx <= popIdx - 2) ? 'modal' : (curIdx === popIdx - 1) ? 'sheet' : 'soft';
    var ratio = reco.area / cur.area;
    return { cur: cur, reco: reco, treatment: treatment, angle: (ratio >= 1.8 ? 'scale' : 'delta'), popularTag: (popIdx >= 0 && reco === sizes[popIdx]) };
  }

  // Frequency cap — once per product per session.
  function productKey() { return 'drool-sizeup:' + location.pathname; }
  function alreadyShown() { try { return sessionStorage.getItem(productKey()) === '1'; } catch (e) { return false; } }
  function markShown() { try { sessionStorage.setItem(productKey(), '1'); } catch (e) {} }

  function money(n) { return isFinite(n) ? '£' + (Math.round(n * 100) % 100 ? n.toFixed(2) : n.toFixed(0)) : ''; }

  function build() {
    if (SHEET) return;
    SCRIM = document.createElement('div'); SCRIM.className = 'drool-sizeup-scrim';
    SHEET = document.createElement('div'); SHEET.className = 'drool-sizeup-sheet'; SHEET.setAttribute('role', 'dialog');
    document.body.appendChild(SCRIM); document.body.appendChild(SHEET);
    SCRIM.addEventListener('click', dismiss);
  }
  function open() { build(); var go = function () { SCRIM.classList.add('open'); SHEET.classList.add('open'); }; requestAnimationFrame(go); setTimeout(go, 40); }
  function hide() { if (SHEET) { SHEET.classList.remove('open'); SCRIM.classList.remove('open'); } }
  function dismiss() { hide(); addThrough(); } // X / scrim / click-away = keep → add the chosen size

  function artworkSrc() {
    try {
      var im = document.querySelector('.mrk-featured-media img') ||
               document.querySelector('media-gallery img:not(.mrk-frame-image-item)');
      return im ? (im.currentSrc || im.src || '') : '';
    } catch (e) { return ''; }
  }
  function scaleBoxes(cur, reco) {
    var maxLin = Math.sqrt(reco.area) || 1;
    var img = artworkSrc();
    var inner = img ? '<img class="dsu-img" src="' + img + '" alt="" loading="lazy">' : '';
    function box(s, isReco) {
      var h = Math.max(34, Math.round(118 * Math.sqrt(s.area) / maxLin));
      var w = Math.round(h * 0.72);
      return '<div class="dsu-box' + (isReco ? ' reco' : '') + '" style="width:' + w + 'px;height:' + h + 'px">' +
        inner + '<span class="dsu-cap">' + s.name + '</span></div>';
    }
    return '<div class="dsu-scale">' + box(cur, false) + box(reco, true) + '</div>';
  }

  // Set the size on the CARDS picker only. Never dispatch a change on the stock
  // picker — its <variant-picker> morph grabs the first variant-picker in the
  // fetched section (the cards one) and would re-render the stock arm as a
  // duplicate of the cards. The shared price/cart follows the cards' event.
  function selectSizeEverywhere(value) {
    Array.prototype.forEach.call(
      document.querySelectorAll('.drool-picker-cards input[type=radio]'),
      function (r) {
        if (/size/i.test(r.name || '') && r.value === value && !r.checked) {
          r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  // The theme's own current-variant truth — option1 is the size.
  function currentSize() {
    try { return JSON.parse(document.querySelector('#mrk-main-variant-data').textContent).option1; } catch (e) { return null; }
  }

  function liveAtc() { return document.querySelector('button.mrk-main-add-to-cart'); }
  function idInput() { return document.querySelector('product-form-component [name="id"], form[action*="/cart/add"] [name="id"]'); }

  function content(cfg) {
    var cur = cfg.cur, reco = cfg.reco;
    var mult = Math.round(reco.area / cur.area * 10) / 10;
    var d = reco.price - cur.price;
    var html = '<button class="dsu-x" aria-label="Close">×</button>';
    if (cfg.angle === 'scale') {
      html += '<h3 class="dsu-h">See it bigger?</h3>' +
        '<p class="dsu-sub">The ' + reco.name + ' is ' + mult + '× the size of the ' + cur.name + ' on your wall.</p>' +
        scaleBoxes(cur, reco) +
        '<div class="dsu-reco">' + (cfg.popularTag ? '<span class="dsu-tag">Popular</span>' : '') +
          '<b>' + reco.name + '</b>' + (reco.dim ? ' · ' + reco.dim : '') + ' · <span class="dsu-up">' + mult + '× bigger' + (isFinite(d) ? ' · +' + money(d) : '') + '</span></div>';
    } else {
      // small step → lead with the price, skip the scale diagram (it barely moves)
      html += '<h3 class="dsu-h">Go one size up?</h3>' +
        '<p class="dsu-sub">' + reco.name + ' is ' + mult + '× bigger — for just +' + money(d) + '.</p>' +
        '<div class="dsu-reco"><b>' + reco.name + '</b>' + (reco.dim ? ' · ' + reco.dim : '') + ' · <span class="dsu-up">+' + money(d) + '</span></div>';
    }
    html += '<div class="dsu-ctas">' +
      '<button class="dsu-btn dsu-up-btn">' + (cfg.angle === 'scale' ? 'Add ' + reco.name + ' instead — ' + money(reco.price) : 'Size up to ' + reco.name + ' — +' + money(d)) + '</button>' +
      '<button class="dsu-btn dsu-ghost dsu-keep-btn">No thanks, keep ' + cur.name + ' — ' + money(cur.price) + '</button>' +
    '</div>';
    return html;
  }

  function showTreatment(cfg) {
    try {
      build();
      SHEET.className = 'drool-sizeup-sheet' + (cfg.treatment === 'modal' ? ' is-modal' : cfg.treatment === 'soft' ? ' is-soft' : '');
      SHEET.innerHTML = content(cfg);
      SHEET.querySelector('.dsu-x').addEventListener('click', dismiss);
      SHEET.querySelector('.dsu-keep-btn').addEventListener('click', function () { hide(); addThrough(); });
      SHEET.querySelector('.dsu-up-btn').addEventListener('click', function () { hide(); upgradeThenAdd(cfg); });
      open();
      markShown();
      return true;
    } catch (e) { return false; }
  }

  // Re-click the theme's own add button (always re-queried live). bypass is
  // ALWAYS cleared on a timer so it can never get stuck and skip a later add.
  function addThrough() {
    try { var a = liveAtc(); if (a) { bypass = true; a.click(); } }
    catch (e) {}
    finally { setTimeout(function () { bypass = false; }, 0); }
  }

  // Upgrade = switch to the recommended size, then add — but only AFTER the
  // variant has settled (the form's hidden id changes), so we never click a
  // half-morphed form. Falls back after ~3s.
  function upgradeThenAdd(rec) {
    try {
      var val = rec.reco.value;
      if (currentSize() === val) { addThrough(); return; }
      selectSizeEverywhere(val);
      var tries = 0;
      (function poll() {
        tries++;
        if (currentSize() === val || tries >= 30) setTimeout(addThrough, 180); // theme variant settled, or ~3s fallback
        else setTimeout(poll, 100);
      })();
    } catch (e) { addThrough(); }
  }

  // Capture-phase intercept on the main add-to-cart button.
  document.addEventListener('click', function (e) {
    if (bypass) { bypass = false; return; }          // our own re-dispatched click: let it through
    try {
      var btn = e.target.closest && e.target.closest('button, [type="submit"]');
      if (!isMainAdd(btn)) return;
      var fs = fieldset();
      if (!isEnabled(fs) || !armVisible()) return;    // off, or not the B arm → normal add
      if (alreadyShown()) return;                      // frequency cap → normal add
      var cfg = config(fs);
      if (!cfg) return;                                // biggest / nothing to push → normal add
      // Defer the native add and route it through the sheet; if the sheet fails to
      // open we DON'T block, so the add proceeds normally.
      if (showTreatment(cfg)) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    } catch (err) { /* fail open: never block the add */ }
  }, true);

})();
